import Vue from 'vue';
import store from '@/store/store';
import TocVueModules from 'tspuser-toc-vue-modules';
import App from './App';
import router from './router';

import '@/assets/styles/global.styl';

if (process.env.VUE_APP_ENV !== 'prod') {
  // eslint-disable-next-line
  const vconsole = new VConsole();
}

router.afterEach(() => {
  window.scrollTo(0, 0);
});
Vue.config.productionTip = false;
Vue.use(TocVueModules);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
